import React, { useMemo } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { selectedCustomerIdAtom } from '../../Atoms';
import { MainDiv } from '../../Theme/StyledComponents';
import CustomerComponents from '../../Pages/CustomerPage/CustomerComponents';
import { flatRoutesAtom } from '../routeAtoms';
import useLocationName from '../../Hooks/useLocationName';
import LeadComponents from '../../Pages/LeadsManagement/Leads/Components/LeadComponents';

const MainOutlet = function MainOutlet({
  handleChangeSection,
  tablet = true,
  heightQuery = true,
  userRoles = [],
  reloadActivityOutcomes,
  sidebarOpen = false,
  priorities = [],
}) {
  const location = useLocation().pathname;

  const customerId = useAtomValue(selectedCustomerIdAtom);
  const routes = useAtomValue(flatRoutesAtom);
  const sectionName = useLocationName();

  // Memoised: a new object re-renders the whole page, and this component also renders whenever
  // the sidebar opens or closes, which the page has no part in.
  const context = useMemo(
    () => ({
      handleChangeSection,
      sectionName,
      reloadActivityOutcomes,
      heightQuery,
      tablet,
      userRoles,
      priorities,
    }),
    [
      handleChangeSection,
      sectionName,
      reloadActivityOutcomes,
      heightQuery,
      tablet,
      userRoles,
      priorities,
    ]
  );

  return (
    <MainDiv location={location} customerId={customerId} routes={routes}>
      <Outlet context={context} />
      <CustomerComponents sidebarOpen={sidebarOpen} />
      <LeadComponents />
    </MainDiv>
  );
};

export default MainOutlet;
